import List from '@/screens/issues/List'

import auth from './middleware/auth'

const routes = [
  {
    path: '/issues',
    name: 'Issues',
    component: List,
    meta: { requireAuth: true },
    permissions: ['provider'],
    middleware: { auth }
  }
]

export default routes
